import React from 'react';
import { FormattedMessage } from 'react-intl';

import BasePage from '@ts-core/pages/BasePage';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import ChangePasswordForm from '@ts-core/modules/auth/components/ChangePasswordForm';
import BasicProfileInfoForm from '@ts-core/modules/auth/components/BaseProfileInfoForm';

import { usePasswordActions, useProfileActions } from '@ts-core/modules/auth/hooks';

import { useStudentAuth } from 'modules/account/hooks';

const StudentProfilePage = () => {
  const { user } = useStudentAuth();
  const { onChangePassword, changePasswordLoading, changePasswordError } = usePasswordActions();

  const { onUpdateProfile, updateProfileLoading, updateProfileError } = useProfileActions();

  return (
    <BasePage>
      <Typography variant="h6">
        <FormattedMessage id="profile.title" />
      </Typography>
      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <BasicProfileInfoForm
                  profileData={{
                    name: user?.name || '',
                    email: user?.email || '',
                  }}
                  onSubmit={onUpdateProfile}
                  isSubmitting={updateProfileLoading}
                  submitError={updateProfileError}
                />
              </Grid>
              <Grid item xs={12}>
                <ChangePasswordForm onSubmit={onChangePassword} isSubmitting={changePasswordLoading} submitError={changePasswordError} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </BasePage>
  );
};

export default StudentProfilePage;
